import { z } from 'zod/v4';

export enum LeadTimeFormat {
  BOTH = 'BOTH',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
}

export const leadTimeFormatSchema = z.enum(LeadTimeFormat);
